import { Component, Renderer2, TemplateRef, ViewChild, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { TopNavService } from './top-navigation.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { qmsService } from '../qms/qms.service';
import { messageService } from '../message.service';
import { ActivityGridComponent } from '../qms/activity-grid/activity-grid.component';
import { Router } from '@angular/router';
import { AuService } from '../qms/au/au.service';
import { AppService } from '../app.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { AuComponent } from '../qms/au/au.component';
import * as moment from 'moment';
import { BusinessAreaService } from '../business-area/business-area.service';
import { Location } from '@angular/common';
import { HomepagetagComponent } from '../homepagetag/homepagetag.component';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss']
})
export class TopNavigationComponent implements OnInit, AfterViewInit, OnDestroy {

  tempuserModuleList: any;
  tempselectedModuleName: any;
  tempuserModuleList1: any = [];
  tempselectedModuleName12: any;

  constructor(private readonly _location: Location, public dialog: MatDialog, public topNavService: TopNavService, private readonly renderer: Renderer2,
    public qmsservice: qmsService, public message: messageService, public activityGridComponent: ActivityGridComponent, public dashboardComponent: DashboardComponent,
    public router: Router, public auService: AuService, private readonly appService: AppService, private readonly snackBar: MatSnackBar,
    public aucompoent: AuComponent, private readonly businessAreaService: BusinessAreaService) { };

  isProcessing: boolean = true;
  popupTitle: any;
  defaultGroupList: any = [];
  userModuleList: any;
  userGroupList: any = [];
  groupValueDropdown: any = [];
  selectedGroupValue: any = [];
  checkTheSupportUser: any = [];

  selectedModule: any;
  oneQmsOrgUsersDetails: any;
  oneQmsOrgImagesDetails: any;
  moduleChildrens: any;
  releasestoShow: boolean = false;
  visibleValidationConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('groupPopup', { static: true }) groupPopup: TemplateRef<any>;

  visiblenewgroupConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('newgroupPopup', { static: true }) newgroupPopup: TemplateRef<any>;

  visibleBpreviwConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('businessPsop', { static: true }) businessPsop: TemplateRef<any>;

  visibleNotificationPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('notificationPopup', { static: true }) notificationPopup: TemplateRef<any>;
  groupPopupConfig = {
    width: '450px',
    height: '300px',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  notificationPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  businessPsopConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  orgDetail: any = {};

  showCustomUserGuide: boolean = false;
  ngOnInit(): void {
    this.timezone = localStorage.getItem("timezone");
    if (this.timezone == "null") {
      this.timezone = "GMT"
    }
    this.popupTitle = "Select Group";
    this.isProcessing = false;

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.orgDetail = data;
    });
    this.appService.getUserDetailsForTrainingDashboard().subscribe((data: any) => {
      this.orgDetail1 = data[0];
      sessionStorage.setItem('userDetails', JSON.stringify(this.orgDetail1));

    });
    this.appService.getOneQmsUserDetails().subscribe((response: any) => {
      this.oneQmsOrgUsersDetails = response;
      this.qmsservice.getOneQmsOrgUsersDetails = response;
      sessionStorage.setItem('oneQmsOrgUsersDetails', JSON.stringify(response));
    })

    this.appService.getAllOrgReportImages().subscribe((response1: any) => {
      this.oneQmsOrgImagesDetails = response1;
      this.showCustomUserGuide = this.oneQmsOrgImagesDetails?.clientUserGuide;
    })
    this.topNavService.getDistinctGroupList().subscribe((response1: any) => {
      this.userGroupList = response1;
      this.selectBoxeForGroupValue();
    });
    this.isProcessing = true;
    this.topNavService.getDistinctModules().subscribe((response1: any) => {
      this.qmsservice.userModuleList = response1;
      this.isProcessing = false;
    });
    this.isProcessing = true;
    this.topNavService.usersGroupModules(this.qmsservice.SelectedGroupNameAndValue[0].valueExp ?? 0).subscribe((response1: any) => {
      this.qmsservice.userModuleList1 = response1;
      const value = this.qmsservice.userModuleList1.filter((x: any) => x.module === this.qmsservice.moduleName);
      if (value.length > 0) {
        this.qmsservice.showReportSection = value[0].reportViewer == 'Y';
      }
      this.isProcessing = false;
    });
  }

  timezone: any;
  private timeInterval: any;

  ngAfterViewInit() {

    let dt = new Date();
    this.convertTZ(dt, this.timezone);

    // Start the time update interval (every minute)
    this.startTimeUpdateEverySecond();

    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef && this.dismissSnackBar) {
        this.snackbarRef.dismiss();
      } else {
        this.dismissSnackBar = true;
      }
    });
  }



  // Alternative method to update time every second (for more frequent updates)
  startTimeUpdateEverySecond() {
    // Clear any existing interval
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }

    // Update time every second (1000 milliseconds)
    this.timeInterval = setInterval(() => {
      let dt = new Date();
      this.convertTZ(dt, this.timezone);
    }, 10);
  }

  convertTZ(date: Date, timezone: any) {
    let dt = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: timezone }));
    let month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    let date2 = dt.getFullYear() + "-" + month_names[dt.getMonth()] + "-" + dt.getDate();
    let date1 = moment(date2).format(this.appService.organizationDetails?.htmlDateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.htmlDateFormat.toUpperCase());
    let hours: any = dt.getHours();
    let minutes: any = dt.getMinutes();
    let seconds: any = dt.getSeconds();

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    let strTime = hours + ':' + minutes + ':' + seconds;

    let uiTime = document.getElementById('dateTime') as HTMLInputElement;
    uiTime.innerHTML = date1 + " " + strTime;
  }

  vendorNavigate() {
    this.qmsservice.highlightgridsection = "Vendor";
    this.router.navigate(['/dashboard/vendors']);
  }
  MasterNavigate() {
    this.qmsservice.highlightgridsection = "AUMaster";
    this.router.navigate(['/dashboard/auMaster']);
  }
  // showmasterMethod(usermodule:any){
  //   let returndata:boolean=false;
  //   if(usermodule.gridViewer=='Y' && usermodule.module=='AU'){
  //     returndata=true;
  //   }
  //   let arraylist=usermodule.qmsRoles.split(",");
  //   if(arraylist.length>0){
  //     if(arraylist.indexOf('Scheduler')!=-1||arraylist.indexOf('Planner')!=-1||arraylist.indexOf('Auditor')!=-1){
  //       returndata=true;
  //      }
  //   }else{
  //     returndata=false;
  //   }
  //   return returndata;
  // }


  module: any;
  subModuleSelect() {
    this.module = this.qmsservice.topNavModule;
    this.qmsservice.userModuleList = this.topNavService.moduleChildrens;
    this.message.breadcrumbData.thirdLevel = null;
    this.message.breadcrumbData.fourthLevel = null;
    if (this.qmsservice.topNavModule == "Trainings") {
      this.selectedVal = "My Trainings";
      this.message.breadcrumbData.secondLevel = "My Trainings";
      this.message.breadcrumbData.thirdLevel = null;
      this.appService.myTraining = "mainPage";
      this.router.navigate(['/dashboard/trainingDashboard']);
    } else if (this.qmsservice.topNavModule == "Documents") {
      this.selectedVal = "Repository";
      this.message.breadcrumbData.secondLevel = "Repository";
      this.message.breadcrumbData.thirdLevel = null;
      this.router.navigate(['/dashboard/rootFolder']);
    } else if (this.qmsservice.topNavModule == "Logs") {
      this.selectedVal = "Logs";
      this.message.breadcrumbData.secondLevel = "Logs";
      this.message.breadcrumbData.thirdLevel = null;
      this.router.navigate(['/dashboard/formsAndLogs']);
    } else {
      this.selectedVal = "Manage";
      this.message.breadcrumbData.secondLevel = "Manage";
      this.message.breadcrumbData.thirdLevel = null;
      this.router.navigate(['/dashboard/businessArea/manage']);
    }
    for (const element of this.qmsservice.userModuleList) {
      if (element.name == "My Trainings") {
        element.icon = "training_module/my-trainings"
      } else if (element.name == "Manage Trainings") {
        element.icon = "training_module/manage-training"
      } else if (element.name == "Instructor Trainings") {
        element.icon = "training_module/Instructor Training"
      } else if (element.name == "User Trainings") {
        element.icon = "training_module/User Training"
      } else if (element.name == "Reports") {
        element.icon = "training_module/report"
      } else if (element.name == "Search") {
        element.icon = "DMS/search"
      } else if (element.name == "Repository") {
        element.icon = "DMS/Repository_"
      } else if (element.name == "Issuance Tracking") {
        element.icon = "DMS/isuance_tracking"
      } else if (element.name == "Destruction Tracking") {
        element.icon = "DMS/collapse"
      } else if (element.name == "Manage") {
        element.icon = "training_module/manage-training"
      } else if (element.name == "Logs") {
        element.icon = "training_module/manage-training"
      }
    }
  }

  executionDetails: any = {
    "executionId": "",
    "workflowStageId": "",
    "module": "",
    "saveButtonForexcution": true,
    "status": ""


  };
  cancelbusinessPopup() {
    this.visibleBpreviwConfirm.close();
  }

  reviewApprove() {
    this.executionDetails.executionId = this.appService.excutionDetails.EXECUTION_ID;
    this.executionDetails.workflowStageId = this.appService.excutionDetails.WORKFLOW_STAGE_ID;
    this.executionDetails.module = "BP_SETUP_exp"
    this.executionDetails.status = this.appService.excutionDetails.STATUS;
    this.visibleBpreviwConfirm = this.dialog.open(this.businessPsop, this.businessPsopConfig);

  }


  selectedVal: any;
  redirectPage(val: any) {
    this.topNavService.selectedVal = val.name;
    this.message.breadcrumbData.secondLevel = val.name;
    this.message.breadcrumbData.thirdLevel = null;
    this.message.breadcrumbData.fourthLevel = null;
    if (val.name == "My Trainings") {
      this.router.navigate(['/dashboard/trainingDashboard']);
    } else if (val.name == "Manage Trainings") {
      this.router.navigate(['/dashboard/manageTraining/Manage']);
    } else if (val.name == 'Instructor Trainings') {
      this.router.navigate(['/dashboard/scheduledTrainings']);
    } else if (val.name == 'Reports' && this.qmsservice.topNavModule == "Trainings") {
      this.message.showRetakeAndMarkasCompleted = false;
      this.router.navigate(['/dashboard/tmsReport']);
    } else if (val.name == 'Reports' && this.qmsservice.topNavModule == "Logs") {
      this.router.navigate(['/dashboard/FormsAndLogsReports']);
    } else if (val.name == 'Logs') {
      this.router.navigate(['/dashboard/formsAndLogs']);
    } else if (val.name == 'Search') {
      this.router.navigate(['/dashboard/subFolder/Search']);
    } else if (val.name == 'Repository') {
      this.router.navigate(['/dashboard/rootFolder']);
    } else if (val.name == 'Issuance Tracking') {
      this.message.isIssuanceFrom = "Document";
      this.router.navigate(['/dashboard/documentIssuanceHistory']);
    } else if (val.name == 'Destruction Tracking') {
      this.message.isIssuanceFrom = "Document";
      this.router.navigate(['/dashboard/documentDestructionsHistory']);
    } else if (val.name == "Reports" && this.qmsservice.topNavModule == "Documents") {
      this.router.navigate(['/dashboard/DmsMainReportComponent']);
    } else if (val.name == "Manage") {
      this.router.navigate(['/dashboard/businessArea/manage']);
    }
  }

  getInsideSubMenu(val: any, parent: any) {
    this.message.breadcrumbData.secondLevel = parent;
    this.message.breadcrumbData.thirdLevel = val.name;
    if (val.name == "Manage") {
      this.router.navigate(['/dashboard/TmsUserManageTrainingsReport']);
    } else if (val.name == "Review") {
      this.router.navigate(['/dashboard/TmsUserTrainingReviewPeriodComponent']);
    }

  }

  opengroupPopup() {
    this.tempselectedModuleName = null;
    this.tempselectedModuleName1 = null;
    this.isProcessing = true;

    this.tempuserModuleList = [];
    this.selectedGroupValue = this.qmsservice.groupNameAndValue;
    this.topNavService.getDistinctGroupList().subscribe({
      next: (response1: any) => {
        this.userGroupList = response1;
        if (this.selectedGroupValue.length > 0) {
          this.topNavService.usersGroupModules(this.selectedGroupValue[0].valueExp).subscribe((response1: any) => {
            this.tempuserModuleList = response1;
            this.isProcessing = false;
          });
        }

        this.isProcessing = false;
        this.selectBoxeForGroupValue();
        this.visibleValidationConfirm = this.dialog.open(this.groupPopup, this.groupPopupConfig);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  orgDetail1: any = {};
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  singleSelectDropdownSetting1: IDropdownSettings = {
    idField: 'module',
    textField: 'moduleName',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  mangeModuleSelect(value1: any) {

    this.message.breadcrumbData.fourthLevel = null;
    this.qmsservice.moduleName = value1;
    if (this.qmsservice.moduleName == "AU") {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.auService.auditPageFrom = "Main";
      this.message.changeRequestCode = "AU";
      this.qmsservice.moduleName = "AU";
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      const data = this.router.url.split("/");
      if (data.at(-1) == "au") {
        this.aucompoent.reloadCurrentRoute();
      } else {
        this.router.navigate(['/dashboard/au']);
      }

      this.isProcessing = false;
    } else if (this.qmsservice.moduleName == 'CR') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = value1;
      this.qmsservice.moduleName = value1;
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = value1;
      this.message.showComplaintSwitch = false;
      this.isProcessing = false;
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      const data = this.router.url.split("/");
      if (data.at(-1) == value1 && data.at(-2) != "ActivityReportComponent") {
        this.activityGridComponent.reloadCurrentRoute();
      } else {
        this.router.navigate(['/dashboard/ActivityCR', value1]);
      }
      this.highlightmethod("Change Request");
      this.topNavService.selectedVal = "Change Request";

    } else if (this.qmsservice.moduleName == 'CAPA') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = "CAPA";
      this.qmsservice.moduleName = "CAPA";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = value1;
      const data = this.router.url.split("/");
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      if (data.at(-1) == value1 && data.at(-2) != "ActivityReportComponent") {
        this.activityGridComponent.reloadCurrentRoute();
      } else {
        this.router.navigate(['/dashboard/ActivityCR', value1]);
      }
      this.highlightmethod(value1);

    } else if (this.qmsservice.moduleName == 'DV') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = "DV";
      this.qmsservice.moduleName = "DV";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = value1;
      const data = this.router.url.split("/");
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      if (data.at(-1) == value1 && data.at(-2) != "ActivityReportComponent") {
        this.activityGridComponent.reloadCurrentRoute();
      } else {
        this.router.navigate(['/dashboard/ActivityCR', value1]);
      }
    } else if (this.qmsservice.moduleName == 'IN') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = "IN";
      this.qmsservice.moduleName = "IN";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = value1;
      this.message.showIncidentSwitch = false;
      const data = this.router.url.split("/");
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      if (data.at(-1) == value1 && data.at(-2) != "ActivityReportComponent") {
        this.activityGridComponent.reloadCurrentRoute();
      } else {
        this.router.navigate(['/dashboard/ActivityCR', value1]);
      }
    } else if (this.qmsservice.moduleName == 'QI') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = "QI";
      this.qmsservice.moduleName = "QI";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = value1;
      const data = this.router.url.split("/");
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      if (data.at(-1) == value1 && data.at(-2) != "ActivityReportComponent") {
        this.activityGridComponent.reloadCurrentRoute();
      } else {
        this.router.navigate(['/dashboard/ActivityCR', value1]);
      }
    } else if (this.qmsservice.moduleName == 'CC') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = "CC";
      this.qmsservice.moduleName = "CC";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = value1;
      this.message.showComplaintSwitch = false;
      const data = this.router.url.split("/");
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      if (data.at(-1) == value1 && data.at(-2) != "ActivityReportComponent") {
        this.activityGridComponent.reloadCurrentRoute();
      } else {
        this.router.navigate(['/dashboard/ActivityCR', value1]);
      }
    }

  }
  tempselectedModuleName1: any;
  viewFunc(menuName: any, event: Event) {
    this.tempselectedModuleName = menuName;
  }

  redirectnavb(menuName1: any) {

    const menuName12 = this.tempuserModuleList.find((x: any) => x.module === menuName1.module);
    const menuName = menuName12;

    if (menuName.gridViewer == 'Y') {
      this.mangeModuleSelect(menuName.module);
      this.topNavService.selectedVal = menuName.moduleName;

      this.highlightmethod(menuName.moduleName);
      this.visibleValidationConfirm.close();
    } else {


      this.qmsservice.moduleName = menuName.moduleName;

      let value1 = menuName.module;
      if (value1 == "CR") {
        this.message.changeRequestCode = "CR";
        this.qmsservice.moduleName = "CR";
        this.router.navigate(['/dashboard/ActivityReportComponent', "CR"]);
      } else if (value1 == "CAPA") {
        this.message.changeRequestCode = "CAPA";
        this.qmsservice.moduleName = "CAPA";
        this.router.navigate(['/dashboard/ActivityReportComponent', "CAPA"]);
      }
      else if (value1 == "DV") {
        this.message.changeRequestCode = "DV";
        this.qmsservice.moduleName = "DV";
        this.router.navigate(['/dashboard/ActivityReportComponent', "DV"]);
      } else if (value1 == "IN") {
        this.message.changeRequestCode = "IN";
        this.qmsservice.moduleName = "IN";
        this.router.navigate(['/dashboard/ActivityReportComponent', "IN"]);
      } else if (value1 == "QI") {
        this.message.changeRequestCode = "QI";
        this.qmsservice.moduleName = "QI";
        this.router.navigate(['/dashboard/ActivityReportComponent', "QI"]);
      } else if (value1 == "AU") {
        this.message.changeRequestCode = "AU";
        this.qmsservice.moduleName = "AU";
        this.router.navigate(['/dashboard/ActivityReportComponent', "AU"]);
      } else if (value1 == "CC") {
        this.message.changeRequestCode = "CC";
        this.qmsservice.moduleName = "CC";
        this.router.navigate(['/dashboard/ActivityReportComponent', "CC"]);
      }
      this.highlightmethod(menuName.moduleName);
      this.visibleValidationConfirm.close();

    }
  }
  cancelGroupSelected() {
    this.visibleValidationConfirm.close();
  };
  cancelnewGrouppopupSelected() {
    this.visiblenewgroupConfirm.close();
  };

  onSelectedmodule(item: any) {
    this.tempselectedModuleName12 = null
    if (item != null) {
      this.tempselectedModuleName12 = item.module;
      this.tempselectedModuleName = item;
    }
  }


  selectedModuleName: any;

  highlightmethod(value: any) {
    this.message.breadcrumbData.fourthLevel = null;
    this.selectedModuleName = value;
    this.selectedVal = value;
  }

  ngOnDestroy() {
    /* Cleaning up the listeners */
    if (this.clickListener) {
      this.clickListener();
    }

    /* Clean up the time interval */
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  }

  private clickListener: () => void;

  snackbarRef: any;
  dismissSnackBar: boolean = true;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.thirdLevel
          : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  groupSelection(value: any, validation: boolean) {
    if (!this.selectedGroupValue.length) {
      this.dismissSnackBar = false;
      this.showSnackBar('Please select the Group', 'E');
    } else if ((!Array.isArray(this.tempselectedModuleName1) && !this.tempselectedModuleName1) || (Array.isArray(this.tempselectedModuleName1) && !this.tempselectedModuleName1.length)) {
      this.dismissSnackBar = false;
      this.showSnackBar('Please select the Module', 'E');
    } else {
      this.moduleMethod(value, validation)
    }
  }

  moduleMethod(value: any, validation: boolean) {
    this.selectedVal = value;
    value = value ?? null;
    this.selectedModule = value;
    this.qmsservice.moduleName = value;
    this.groupSelected(value, validation);
  }

  reportModuleMethod(finalValue: any) {

    this.qmsservice.highlightgridsection = "Report";
    this.qmsservice.highlightReportSection = true;

    this.selectedModule = finalValue;
    this.qmsservice.moduleName = finalValue;

    this.reportSelected(finalValue);
  }

  reportSelected(value1: any) {

    if (value1 == "CR") {
      this.message.changeRequestCode = "CR";
      this.qmsservice.moduleName = "CR";
      this.router.navigate(['/dashboard/ActivityReportComponent', "CR"]);
    } else if (value1 == "CAPA") {
      this.message.changeRequestCode = "CAPA";
      this.qmsservice.moduleName = "CAPA";
      this.router.navigate(['/dashboard/ActivityReportComponent', "CAPA"]);
    }
    else if (value1 == "DV") {
      this.message.changeRequestCode = "DV";
      this.qmsservice.moduleName = "DV";
      this.router.navigate(['/dashboard/ActivityReportComponent', "DV"]);
    } else if (value1 == "IN") {
      this.message.changeRequestCode = "IN";
      this.qmsservice.moduleName = "IN";
      this.router.navigate(['/dashboard/ActivityReportComponent', "IN"]);
    } else if (value1 == "QI") {
      this.message.changeRequestCode = "QI";
      this.qmsservice.moduleName = "QI";
      this.router.navigate(['/dashboard/ActivityReportComponent', "QI"]);
    } else if (value1 == "AU") {
      this.message.changeRequestCode = "AU";
      this.qmsservice.moduleName = "AU";
      this.router.navigate(['/dashboard/ActivityReportComponent', "AU"]);
    } else if (value1 == "CC") {
      this.message.changeRequestCode = "CC";
      this.qmsservice.moduleName = "CC";
      this.router.navigate(['/dashboard/ActivityReportComponent', "CC"]);
    } else if (value1 == "OOS") {
      this.message.changeRequestCode = "OOS";
      this.qmsservice.moduleName = "OOS";
      this.router.navigate(['/dashboard/ActivityReportComponent', "OOS"]);
    }
  }





  popupDataTitle: PopupData = {
    title: ''
  };

  @ViewChild('uploadImagesPopup', { static: true }) uploadImagesPopup: TemplateRef<any>;
  @ViewChild('uploadImagesPopup1', { static: true }) uploadImagesPopup1: TemplateRef<any>;
  visibleUploadImagesPopup: MatDialogRef<TemplateRef<any>>;
  visibleUploadImagesPopup1: MatDialogRef<TemplateRef<any>>;

  uploadImagesPopupConfig = {
    width: '30%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  imageUploadFlag: any;
  uploadInputFiledValue: any;
  imageToUpload: any;
  profileImage: any;
  readURL(event: any): void {
    if (event.target.files?.[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = e => this.profileImage = reader.result;
      reader.readAsDataURL(file);
    }
  }
  openUserImageUploadPopup() {
    this.profileImage = null;
    this.imageToUpload = null;
    this.popupDataTitle.title = "User Profile";
    this.imageUploadFlag = "User";
    this.visibleUploadImagesPopup1 = this.dialog.open(this.uploadImagesPopup1, this.uploadImagesPopupConfig);
  }
  imageExtention: any;
  uploadSuccessMsg: any;
  uploadSuccessIcon: any;
  uploadErrorMsg: any;
  uploadErrorIcon: any;
  uploadRequiredMsg: any;
  uploadRequiredIcon: any;
  uploaderrorsizeIcon: any;
  uploaderrorsizeMsg: any;

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    const maxSizeInBytes: number = 1 * 1024 * 1024; // 5 MB

    if (file.size > maxSizeInBytes) {
      alert('File size exceeds the limit (5MB). Please choose a smaller file.');
    }

    // Proceed with your file upload logic here
  }
  logosizeextended = false;
  uploadImages(e: any) {

    this.imageExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();

    this.uploadSuccessMsg = document.getElementById('logo-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('logo-success-icon') as HTMLInputElement;

    this.uploadErrorMsg = document.getElementById('logo-error-msg') as HTMLInputElement;
    this.uploadErrorIcon = document.getElementById('logo-error-icon') as HTMLInputElement;

    this.uploadRequiredMsg = document.getElementById('logo-required-msg') as HTMLInputElement;
    this.uploadRequiredIcon = document.getElementById('logo-required-icon') as HTMLInputElement;

    if (this.imageExtention != "jpg" && this.imageExtention != "png" && this.imageExtention != "jpeg") {
      this.uploadSuccessMsg.style.display = 'none';
      this.uploadSuccessIcon.style.display = 'none';

      this.uploadErrorMsg.style.display = 'block';
      this.uploadErrorIcon.style.display = 'block';
      this.uploadRequiredMsg.style.display = 'none';
      this.uploadRequiredIcon.style.display = 'none';
    } else {

      this.uploadErrorMsg.style.display = 'none';
      this.uploadErrorIcon.style.display = 'none';

      this.uploadRequiredMsg.style.display = 'none';
      this.uploadRequiredIcon.style.display = 'none';
    }

    const file: File = e.target.files[0];
    this.imageToUpload = file;
    const maxSizeInBytes: number = 1 * 500 * 500; // 5 MB
    let FileSizeAllowToupload = false;
    if (file.size > maxSizeInBytes) {

      this.logosizeextended = true;

      FileSizeAllowToupload = true;
    }


    if (file && !FileSizeAllowToupload) {
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "IMAGE");
      formData.append("fileName", name);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.uploadSuccessMsg.style.display = 'block';
              this.uploadSuccessIcon.style.display = 'block';
            } else {
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        })
    }
  }

  uploadImagesValidation() {
    this.uploadSuccessMsg = document.getElementById('logo-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('logo-success-icon') as HTMLInputElement;

    this.uploadErrorMsg = document.getElementById('logo-error-msg') as HTMLInputElement;
    this.uploadErrorIcon = document.getElementById('logo-error-icon') as HTMLInputElement;

    this.uploadRequiredMsg = document.getElementById('logo-required-msg') as HTMLInputElement;
    this.uploadRequiredIcon = document.getElementById('logo-required-icon') as HTMLInputElement;

    if (this.imageToUpload == null || this.imageToUpload == undefined) {
      this.uploadSuccessMsg.style.display = 'none';
      this.uploadSuccessIcon.style.display = 'none';

      this.uploadErrorMsg.style.display = 'none';
      this.uploadErrorIcon.style.display = 'none';

      this.uploadRequiredMsg.style.display = 'block';
      this.uploadRequiredIcon.style.display = 'block';
    }
  }

  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  dataValues: any = {};

  uploadLogoImage() {
    this.isProcessing = true;
    if (this.imageToUpload == null || this.imageToUpload == undefined) {
      this.uploadImagesValidation();
      this.isProcessing = false;
    } else if (this.imageUploadFlag == "Organization") {
      if (this.oneQmsOrgImagesDetails != null || this.oneQmsOrgImagesDetails != undefined) {
        this.dataValues = {
          operation: 'U',
          logoImageExt: this.imageExtention
        };
        const uploadLogoData = new FormData();

        uploadLogoData.append('binaryLogoFile', this.imageToUpload);
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        uploadLogoData.append('oneQmsOrgImagesDto', blob);
        this.appService.updateLogoImage(uploadLogoData).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.isProcessing = false;
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
            this.ngOnInit();
            this.visibleUploadImagesPopup1.close();
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        this.dataValues = {
          operation: 'I',
          logoImageExt: this.imageExtention
        };
        const addLogoData = new FormData();
        addLogoData.append('binaryLogoFile', this.imageToUpload);
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        addLogoData.append('oneQmsOrgImagesDto', blob);
        this.appService.addLogoImage(addLogoData).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.isProcessing = false;
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
            this.ngOnInit();
            this.visibleUploadImagesPopup1.close();
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }
    } else if (this.oneQmsOrgUsersDetails != null || this.oneQmsOrgUsersDetails != undefined) {
      this.dataValues = {
        orgId: this.message.getOrgId(),
        userId: this.message.getUserId(),
        operation: 'U',
        userImageExtn: this.oneQmsOrgUsersDetails.imageExtention
      };
      const uploadLogoData = new FormData();
      uploadLogoData.append('file', this.imageToUpload);
      const json = JSON.stringify(this.dataValues);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      uploadLogoData.append('oneQmsUserDetailsDto', blob);
      this.appService.updateUserImage(uploadLogoData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
          this.ngOnInit();
          this.visibleUploadImagesPopup1.close();
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.dataValues = {
        orgId: this.message.getOrgId(),
        userId: this.message.getUserId(),
        operation: "I",
        userImageExtn: this.imageExtention
      };
      const addLogoData = new FormData();
      addLogoData.append('file', this.imageToUpload);
      const json = JSON.stringify(this.dataValues);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      addLogoData.append('oneQmsUserDetailsDto', blob);
      this.appService.addUserImage(addLogoData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
          this.ngOnInit();
          this.visibleUploadImagesPopup1.close();
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelUploadLogoFunction() {
    this.imageToUpload = null;
    this.visibleUploadImagesPopup1.close();
  }
  homepage() {
    this.qmsservice.showTopNav = false;
    this.message.breadcrumbData = {};
    this.message.showLeftMenu = "Main";

    this.router.navigate(['dashboard']);
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };
  messageCount: any;
  openTopicPopup() {
    this.message.communicatingFrom = 'Dashboard';
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  canceltopicPopup() {
    this.visibleTopicPopup.close();
    this.isProcessing = true;
    this.appService.getOneQmsReceivedTopics().subscribe((response: any) => {
      const topicsData = response;
      this.messageCount = 0;
      for (const topic of topicsData) {
        topic.readAlready == "N" && this.messageCount++;
      }
      this.messageCount = this.messageCount > 99 ? "99+" : this.messageCount;
      this.isProcessing = false;
    })
  }
  @ViewChild('messageHistoryPopup', { static: true }) messageHistoryPopup: TemplateRef<any>;
  visibleMessageHistoryPopup: MatDialogRef<TemplateRef<any>>;
  messageHistoryPopupConfig = {
    width: 'auto',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  logmethod() {
    this.popupDataTitle.title = "Message History";
    this.visibleMessageHistoryPopup = this.dialog.open(this.messageHistoryPopup, this.messageHistoryPopupConfig);
  }
  cancelMessageHistoryFunction() {

    this.visibleMessageHistoryPopup.close();

  }

  openUserGuide() {
    window.open('../assets/OneQMS 3.0.pdf', '_blank', 'fullscreen=yes, toolbar=yes, menubar=yes, scrollbars=yes,width=1000, height=750');
  }

  openCustomUserGuide(): void {
    const base64Pdf = this.oneQmsOrgImagesDetails?.clientUserGuide;

    if (!base64Pdf) {
      return;
    }

    // 1. Convert base64 to PDF Blob
    const blob = this.base64ToPdfBlob(base64Pdf);

    // 2. Create Object URL for the blob
    const fileUrl = URL.createObjectURL(blob);

    // 3. Open in a new tab
    const pdfWindow = window.open(fileUrl, '_blank');

    // 4. Revoke Object URL after tab opens to prevent memory leaks
    if (pdfWindow) {
      pdfWindow.addEventListener('load', () => {
        URL.revokeObjectURL(fileUrl);
      });
    }
  }

  private base64ToPdfBlob(base64Data: string): Blob {
    // Clean base64 header if present (e.g., "data:application/pdf;base64,")
    const cleanBase64 = base64Data.replace(/^data:application\/pdf;base64,/, '');

    // Decode Base64 string to raw binary string
    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    // Explicitly set type to application/pdf so browser PDF viewer triggers
    return new Blob([byteNumbers.buffer as ArrayBuffer], { type: 'application/pdf' });
  }


  support() {
    this.qmsservice.tempSelectedOrginizationName = null;
    this.router.navigate(['/dashboard/support-ticket']);
  }
  releases() {
    this.qmsservice.tempSelectedOrginizationName = null;
    this.router.navigate(['/dashboard/releases']);
  }
  @ViewChild('logoutPopup', { static: true }) logoutPopup: TemplateRef<any>;
  visibleLogoutPopupPopup: MatDialogRef<TemplateRef<any>>;
  logout() {
    this.snackBar.dismiss();
    this.dashboardComponent.logout();
  }

  openNotifications() {
    this.qmsservice.activityId = null;
    this.visibleNotificationPopup = this.dialog.open(this.notificationPopup, this.notificationPopupConfig);
  }

  cancelNotificationPopup() {
    this.visibleNotificationPopup.close();
  }
  goBack(buttonStatus: string) {
    if (buttonStatus === 'Cancel') {
      this._location.back();
    } else {
      let formFieldsaveData = {
        "executionId": this.appService.excutionDetails == null ? 0 : this.appService.excutionDetails.EXECUTION_ID,
        "isConditionSatisfield": "N",
        "saveMode": "Auto",
        "buttonValue": buttonStatus,
        "currentStatus": this.appService.excutionDetails.status,
        "commnent": "cc",
        "satgeName": this.message.businessProcess.stageName,
      }

      this.businessAreaService.getButtonoperationForExecutionLabels(formFieldsaveData).subscribe({
        next: (Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == 'S') { /* empty */ }

          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: Response.resultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });


        }, error: (error: any) => {
          this.isProcessing = false;
          throw error;
        }
      });

    }

  }
  //new
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    for (const element of this.userGroupList) {
      this.groupValueDropdown = this.groupValueDropdown.concat({
        valueExp: element.groupId,
        displayExp: element.groupName
      });
    }
  }

  onSelectedGroup(item: any) {
    this.isProcessing = true;
    this.qmsservice.showGridSection = false;
    this.qmsservice.showReportSection = false;
    if (item != null) {
      this.tempselectedModuleName = null;
      this.qmsservice.moduleName = null
      this.tempuserModuleList1 = [];
      this.topNavService.usersGroupModules(item.valueExp).subscribe({
        next: (response1: any) => {
          this.tempselectedModuleName1 = null;
          this.tempuserModuleList1 = response1.map((item: any) => ({
            valueExp: item.module,
            displayExp: item.moduleName
          }));
          this.groupSelected(null, false);
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });

      const value = [];
      value.push(item);
      this.qmsservice.SelectedGroupNameAndValue = value;

    }
  }


  groupSelected(value1: any, validation: boolean) {
    this.isProcessing = true;
    if (this.qmsservice.SelectedGroupNameAndValue == this.qmsservice.groupNameAndValue && validation) {
      const menuName12 = this.tempuserModuleList.filter((x: any) => x.module === this.tempselectedModuleName1[0].module);
      if (menuName12.length > 0) {
        const data1 = this.router.url.split("/");
        if (data1.at(-1) == this.tempselectedModuleName1[0].module) { /* empty */ } else if (this.tempselectedModuleName1[0].module == 'AU') {
          this.groupSelected('AU', false);
        } else {
          this.redirectnavb(menuName12[0]);
        }
      }

      this.cancelGroupSelected();
      this.isProcessing = false;
    } else {
      this.moduleSelect();
    }
  };

  setgroupandModule(value1: any) {
    if (this.qmsservice.SelectedGroupNameAndValue.length > 0) {
      const data = {
        groupId: this.qmsservice.SelectedGroupNameAndValue[0].valueExp,
        moduleName: value1
      }
      this.topNavService.callSetDefaultGrouop(data).subscribe((Response: any) => {
        this.isProcessing = false;
        this.visibleValidationConfirm.close();
      });
    }
  }
  moduleSelect() {
    this.qmsservice.showGridSection = false;
    this.qmsservice.showReportSection = false;
    this.module = 'Quality';
    this.qmsservice.userModuleList = [];
    this.topNavService.userDefaultGroup().subscribe((response: any) => {
      this.defaultGroupList = response;
      if (this.defaultGroupList.length == 1 && this.defaultGroupList[0]) {

        this.topNavService.usersGroupModules(this.defaultGroupList[0].groupId).subscribe((response1: any) => {
          this.message.breadcrumbData.fourthLevel = null;
          this.qmsservice.userModuleList = response1;
          this.selectedGroupValue = [{
            valueExp: this.qmsservice.userModuleList[0].groupId,
            displayExp: this.qmsservice.userModuleList[0].groupName
          }];
          this.isProcessing = false;
          this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
          this.qmsservice.groupNameAndValue = this.selectedGroupValue;
          let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
          this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
          if (secondlevelid) {
            secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
          }
          if (this.tempselectedModuleName != null) {
            this.selectedModuleName = this.tempselectedModuleName.moduleName;
            this.redirectnavb(this.tempselectedModuleName);
          } else if (this.defaultGroupList[0].module == null) { /* empty */ } else {
            const value = this.qmsservice.userModuleList.filter((x: any) => x.module === this.defaultGroupList[0].module);

            if (value.length > 0) {
              this.qmsservice.showGridSection = value[0].gridViewer == 'Y';
              this.qmsservice.showReportSection = value[0].reportViewer == 'Y';
              this.qmsservice.showVendorMasterSection = (value[0].module == 'AU' && value[0].qmsRoles.includes('Vendor Manager'));
              this.qmsservice.showAuditMasterSection = (value[0].module == 'AU' && value[0].qmsRoles.includes('Master Manager'));
              if (this.qmsservice.showGridSection || this.qmsservice.showReportSection) {
                this.setdefaultmethod();
              }
              this.message.breadcrumbData.fourthLevel = null;
              this.qmsservice.moduleName = this.defaultGroupList[0].module;
              if (this.qmsservice.moduleName == "AU") {
                this.qmsservice.isTriggeredFromDependencies = false;
                this.auService.auditPageFrom = "Main";
                this.message.changeRequestCode = "AU";
                this.qmsservice.moduleName = "AU";
                let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
                this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
                if (secondlevelid) {
                  secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
                }
                const data = this.router.url.split("/");
                if (data.at(-1) == "au") {
                  this.aucompoent.reloadCurrentRoute();
                } else {
                  this.router.navigate(['/dashboard/au']);
                }

                this.isProcessing = false;
              } else if (this.qmsservice.moduleName == 'CR') {
                this.qmsservice.isTriggeredFromDependencies = false;
                this.qmsservice.refereshBreadCrumb = false;
                this.message.changeRequestCode = this.qmsservice.moduleName;
                this.activityGridComponent.ngOnInit();
                this.qmsservice.activityTitle = this.qmsservice.moduleName;
                this.message.showComplaintSwitch = false;
                this.isProcessing = false;
                let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
                this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
                if (secondlevelid) {
                  secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
                }
                const data = this.router.url.split("/");
                if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
                  this.activityGridComponent.reloadCurrentRoute();
                } else {
                  this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
                }

              } else if (this.qmsservice.moduleName == 'CAPA') {
                this.qmsservice.isTriggeredFromDependencies = false;
                this.qmsservice.refereshBreadCrumb = false;
                this.message.changeRequestCode = "CAPA";
                this.qmsservice.moduleName = "CAPA";
                this.activityGridComponent.ngOnInit();
                this.qmsservice.activityTitle = this.qmsservice.moduleName;
                const data = this.router.url.split("/");
                let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
                this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
                if (secondlevelid) {
                  secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
                }
                if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
                  this.activityGridComponent.reloadCurrentRoute();
                } else {
                  this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
                }
              } else if (this.qmsservice.moduleName == 'DV') {
                this.qmsservice.isTriggeredFromDependencies = false;
                this.qmsservice.refereshBreadCrumb = false;
                this.message.changeRequestCode = "DV";
                this.qmsservice.moduleName = "DV";
                this.activityGridComponent.ngOnInit();
                this.qmsservice.activityTitle = this.qmsservice.moduleName;
                const data = this.router.url.split("/");
                let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
                this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
                if (secondlevelid) {
                  secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
                }
                if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
                  this.activityGridComponent.reloadCurrentRoute();
                } else {
                  this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
                }
              } else if (this.qmsservice.moduleName == 'IN') {
                this.qmsservice.isTriggeredFromDependencies = false;
                this.qmsservice.refereshBreadCrumb = false;
                this.message.changeRequestCode = "IN";
                this.qmsservice.moduleName = "IN";
                this.activityGridComponent.ngOnInit();
                this.qmsservice.activityTitle = this.qmsservice.moduleName;
                this.message.showIncidentSwitch = false;
                const data = this.router.url.split("/");
                let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
                this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
                if (secondlevelid) {
                  secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
                }
                if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
                  this.activityGridComponent.reloadCurrentRoute();
                } else {
                  this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
                }
              } else if (this.qmsservice.moduleName == 'QI') {
                this.qmsservice.isTriggeredFromDependencies = false;
                this.qmsservice.refereshBreadCrumb = false;
                this.message.changeRequestCode = "QI";
                this.qmsservice.moduleName = "QI";
                this.activityGridComponent.ngOnInit();
                this.qmsservice.activityTitle = this.qmsservice.moduleName;
                const data = this.router.url.split("/");
                let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
                this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
                if (secondlevelid) {
                  secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
                }
                if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
                  this.activityGridComponent.reloadCurrentRoute();
                } else {
                  this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
                }
              } else if (this.qmsservice.moduleName == 'CC') {
                this.qmsservice.isTriggeredFromDependencies = false;
                this.qmsservice.refereshBreadCrumb = false;
                this.message.changeRequestCode = "CC";
                this.qmsservice.moduleName = "CC";
                this.activityGridComponent.ngOnInit();
                this.qmsservice.activityTitle = this.qmsservice.moduleName;
                this.message.showComplaintSwitch = false;
                const data = this.router.url.split("/");
                let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
                this.message.breadcrumbData.secondLevel = this.selectedModuleName == undefined ? this.qmsservice.moduleName + " > " + this.selectedGroupValue[0].displayExp : this.selectedModuleName + " > " + this.selectedGroupValue[0].displayExp;
                if (secondlevelid) {
                  secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
                }
                if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
                  this.activityGridComponent.reloadCurrentRoute();
                } else {
                  this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
                }
              }
            }
          }
          this.isProcessing = false;
        });

      }

    });
  }

  //newcalls
  opennewgroupPopup() {
    this.visiblenewgroupConfirm = this.dialog.open(this.newgroupPopup, this.groupPopupConfig);
  };

  cancelNewGroupSelected() {
    this.visiblenewgroupConfirm.close();
  };

  moduleSearchText: any = '';
  groupSearchText: any = '';
  setdefaultmethod() {
    if (this.qmsservice.SelectedGroupNameAndValue.length > 0) {
      const data = {
        groupId: this.qmsservice.SelectedGroupNameAndValue[0].valueExp,
        moduleName: this.qmsservice.moduleName
      }
      this.topNavService.callSetDefaultGrouop(data).subscribe((Response: any) => {
        this.isProcessing = false;
        this.newgetcall();
      });
    }
  }
  defaultgroupandmodulenull: boolean = false;
  defaultgroup: any = [];
  defaultmodule: any = null;
  defaultmoduleName: any = null;
  newgetcall() {
    this.module = 'Quality';
    this.qmsservice.userModuleList = [];
    if (this.message.qmsSettings.primarySelectorAtUIPage == "Group") {

      this.topNavService.getDistinctGroupList().subscribe((response1: any) => {
        this.userGroupList = response1;
        this.selectBoxeForGroupValue();
        this.topNavService.userDefaultGroup().subscribe((response: any) => {
          this.qmsservice.defaultGroupList = response;
          if (this.qmsservice.defaultGroupList.length == 1 && this.qmsservice.defaultGroupList[0]) {
            this.defaultgroupandmodulenull = false;
            const value123 = this.userGroupList.filter((x: any) => x.groupId === this.qmsservice.defaultGroupList[0].groupId);
            if (value123.length > 0) {
              this.selectedGroupValue = [{
                valueExp: value123[0].groupId,
                displayExp: value123[0].groupName,
                groupCode: value123[0].groupCode
              }];
            }
            this.message.breadcrumbData.fourthLevel = null;

            this.isProcessing = false;
            this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
            this.qmsservice.groupNameAndValue = this.selectedGroupValue;

            this.newgroupSelet(this.selectedGroupValue[0], "manualGroup");
          } else {
            this.defaultgroupandmodulenull = true;
            this.opennewgroupPopup();
          }
        });
        this.message.primarySelectorAtUIPageList = ["Group", "Module"];
      })
    } else if (this.message.qmsSettings.primarySelectorAtUIPage == "Module") {

      this.topNavService.userDefaultGroup().subscribe((response: any) => {
        this.qmsservice.defaultGroupList = response;
        this.topNavService.getDistinctModules().subscribe((response1: any) => {
          if (this.message.qmsSettings.primarySelectorAtUIPage == "Group") {
            this.message.primarySelectorAtUIPageList = ["Group", "Module"];
          } else if (this.message.qmsSettings.primarySelectorAtUIPage == "Module") {
            this.message.primarySelectorAtUIPageList = ["Module", "Group"];
          }

          this.tempselectedModuleName1 = null;
          this.tempuserModuleList1 = [];
          this.qmsservice.userModuleList = response1;
          this.tempuserModuleList1 = response1.map((item: any) => ({
            valueExp: item.module,
            displayExp: item.moduleName
          }));
          if (this.qmsservice.defaultGroupList[0].module) {
            this.defaultgroupandmodulenull = false;
            let selectedmodule = this.qmsservice.userModuleList.find((x: any) => x.module === this.qmsservice.defaultGroupList[0].module)
            this.qmsservice.moduleFullName = selectedmodule.moduleName;
            this.qmsservice.moduleName = selectedmodule.module;
            let item = {
              module: selectedmodule.module,
              moduleName: selectedmodule.moduleName
            };
            this.newmoduleSelect(item, "manualModule");
          } else {
            this.defaultgroupandmodulenull = true;
            this.opennewgroupPopup();
          }
        });
      });
      //
    }
  };

  newgroupSelet(item: any, from: any) {
    this.qmsservice.showGridSection = false;
    this.qmsservice.showReportSection = false;
    if (item != null) {
      this.tempselectedModuleName = null;
      if (from == 'popupClicked') {
        this.defaultgroup = item
      } else {
        this.qmsservice.SelectedGroupNameAndValue[0] = item;
        this.selectedGroupValue = [item];
        this.message.breadcrumbData.fourthLevel = null;

        this.isProcessing = false;
        this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
        this.qmsservice.groupNameAndValue = this.selectedGroupValue;
      }
      if (this.message.qmsSettings.primarySelectorAtUIPage == "Group") {
        this.message.primarySelectorAtUIPageList = ["Group", "Module"];
        if (from == 'groupClicked') {
          this.qmsservice.moduleFullName = null;
          this.qmsservice.moduleName = null;
          this.qmsservice.showVendorMasterSection = false;
          this.qmsservice.showAuditMasterSection = false;
        }

        this.loadmoduleList(item, from);
      } else if (this.message.qmsSettings.primarySelectorAtUIPage == "Module") {
        this.message.primarySelectorAtUIPageList = ["Module", "Group"];
        if (from == 'groupClicked' && from != "popupClicked") {
          this.qmsservice.showmodulegrid = true;
          this.setdefaultmethod();
        }

      }

    }

  };
  loadMainCall() {
    if (this.defaultmoduleName != null && this.defaultgroup?.displayExp != null) {
      this.qmsservice.SelectedGroupNameAndValue[0] = this.defaultgroup;
      this.selectedGroupValue = [this.defaultgroup];
      this.message.breadcrumbData.fourthLevel = null;

      this.isProcessing = false;
      this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
      this.qmsservice.groupNameAndValue = this.selectedGroupValue;

      this.qmsservice.moduleFullName = this.defaultmoduleName;
      this.qmsservice.moduleName = this.defaultmodule;
      this.visiblenewgroupConfirm.close();
      this.setdefaultmethod();
    } else {
      alert("Please select group and module")
    }

  }
  newmoduleSelect(value1: any, from: any) {

    if (from == 'popupClicked') {
      this.defaultmoduleName = value1?.moduleName;
      this.defaultmodule = value1?.module;
    } else {
      this.qmsservice.moduleFullName = value1?.moduleName;
      this.qmsservice.moduleName = value1?.module;
    }
    if (this.message.qmsSettings.primarySelectorAtUIPage == "Group" && from != "popupClicked") {
      this.qmsservice.showmodulegrid = true;
      this.setdefaultmethod();
    } else if (this.message.qmsSettings.primarySelectorAtUIPage == "Module") {
      if (from == 'moduleClicked') {
        this.qmsservice.SelectedGroupNameAndValue = [];
      }

      this.loadgroupList(value1, from);
    }
  }

  loadmoduleList(item: any, from: any) {
    this.topNavService.usersGroupModules(item.valueExp).subscribe({
      next: (response1: any) => {
        this.tempselectedModuleName1 = null;
        this.tempuserModuleList1 = [];
        this.qmsservice.userModuleList = response1;
        this.tempuserModuleList1 = response1.map((item: any) => ({
          valueExp: item.module,
          displayExp: item.moduleName
        }));

        if (from == "groupClicked") {
          this.qmsservice.defaultGroupList[0].module = null;
          this.qmsservice.showmodulegrid = false;
        }
        let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
        this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName == undefined ? this.qmsservice.moduleName : this.qmsservice.moduleFullName + " > " + this.selectedGroupValue[0].displayExp;
        if (secondlevelid) {
          secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
        }
        if (this.qmsservice.defaultGroupList[0]?.module) {
          this.tempselectedModuleName = this.qmsservice.moduleName = this.qmsservice.defaultGroupList[0].module;
          const value = this.qmsservice.userModuleList.filter((x: any) => x.module === this.qmsservice.defaultGroupList[0].module);
          this.showFields(value);
        }

        else {
          this.tempselectedModuleName = this.qmsservice.moduleName = null;
          this.qmsservice.showGridSection = false;
          this.qmsservice.showReportSection = false;
          this.qmsservice.highlightReportSection = false;
        }
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

    const value = [];
    value.push(item);
    this.qmsservice.SelectedGroupNameAndValue = value;
  };

  showFields(value: any) {
    if (value.length > 0) {
      this.qmsservice.moduleFullName = value[0].moduleName;
      this.qmsservice.showGridSection = value[0].gridViewer == 'Y';
      this.qmsservice.showReportSection = value[0].reportViewer == 'Y';
      this.qmsservice.showVendorMasterSection = ((value[0].module == 'AU' || value[0].module == 'IN') && value[0].qmsRoles.includes('Vendor Manager'));
      this.qmsservice.showAuditMasterSection = (value[0].module == 'AU' && value[0].qmsRoles.includes('Master Manager'));

      if (this.qmsservice.showGridSection || this.qmsservice.showReportSection) {
        if ((this.qmsservice.showGridSection && this.qmsservice.showReportSection) || this.qmsservice.showGridSection) {
          this.qmsservice.highlightgridsection = "Module";
          this.qmsservice.highlightReportSection = false;
          if (this.qmsservice.moduleName && this.qmsservice.SelectedGroupNameAndValue) {
            this.newredirect();
          }

        } else if (this.qmsservice.showReportSection && !this.qmsservice.showGridSection) {
          this.qmsservice.highlightReportSection = true;
          this.qmsservice.highlightgridsection = "Report";
          if (this.qmsservice.moduleName && this.qmsservice.SelectedGroupNameAndValue) {
            this.qmsservice.selectedGroup = this.qmsservice.SelectedGroupNameAndValue[0].valueExp;
            this.message.isTagHomeFromHome = true;
            this.newredirect();
          }

        }
      }
      this.message.breadcrumbData.fourthLevel = null;
    } else {
      this.qmsservice.showGridSection = false;
      this.qmsservice.showReportSection = false;
    }
  }

  loadgroupList(value: any, from: any) {
    if (from == "moduleClicked") {
      this.qmsservice.showmodulegrid = false;
      this.qmsservice.defaultGroupList[0].groupId = null;
      this.qmsservice.SelectedGroupNameAndValue = [];
    }
    this.topNavService.usersModuleGroupListDropdown(from == 'popupClicked' ? this.defaultmodule : this.qmsservice.moduleName).subscribe((response1: any) => {
      this.userGroupList = response1;
      this.selectBoxeForGroupValue();
      if (this.qmsservice.defaultGroupList[0]?.groupId) {
        const value123 = this.userGroupList.filter((x: any) => x.groupId === this.qmsservice.defaultGroupList[0].groupId);
        if (value123.length > 0) {
          this.selectedGroupValue = [{
            valueExp: value123[0].groupId,
            displayExp: value123[0].groupName,
            groupCode: value123[0].groupCode
          }];
          value123[0].moduleName = this.qmsservice.moduleFullName;
          this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
          this.qmsservice.groupNameAndValue = this.selectedGroupValue;
        }
        if (from == "popupClicked") { /* empty */ } else {
          this.showFields(value123);
        }

        this.message.breadcrumbData.fourthLevel = null;

        this.isProcessing = false;

      }
    });
  }


  newredirect() {
    this.qmsservice.highlightgridsection = 'Module';
    this.qmsservice.highlightReportSection = false;
    if (this.qmsservice.moduleName == "AU") {
      this.qmsservice.isTriggeredFromDependencies = false;

      this.auService.auditPageFrom = "Main";
      this.message.changeRequestCode = "AU";
      this.qmsservice.moduleName = "AU";
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName == undefined ? this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp : this.qmsservice.moduleFullName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      const data = this.router.url.split("/");
      if (data.at(-1) == "au") {
        this.aucompoent.reloadCurrentRoute();
      } else if (this.message.isTagHomeFromHome) {
        this.reportModuleMethod(this.qmsservice.moduleName)
        this.message.isTagHomeFromHome = false;
      } else {
        this.router.navigate(['/dashboard/au']);
      }

      this.isProcessing = false;
    } else if (this.qmsservice.moduleName == 'CR') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = this.qmsservice.moduleName;
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = this.qmsservice.moduleName;
      this.message.showComplaintSwitch = false;
      this.isProcessing = false;
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName == undefined ? this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp : this.qmsservice.moduleFullName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      const data = this.router.url.split("/");
      if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
        this.activityGridComponent.reloadCurrentRoute();
      } else if (this.message.isTagHomeFromHome) {
        this.reportModuleMethod(this.qmsservice.moduleName);
        this.message.isTagHomeFromHome = false;
      } else {
        this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
      }

    } else if (this.qmsservice.moduleName == 'CAPA') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = "CAPA";
      this.qmsservice.moduleName = "CAPA";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = this.qmsservice.moduleName;
      const data = this.router.url.split("/");
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName == undefined ? this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp : this.qmsservice.moduleFullName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
        this.activityGridComponent.reloadCurrentRoute();
      } else if (this.message.isTagHomeFromHome) {
        this.reportModuleMethod(this.qmsservice.moduleName);
        this.message.isTagHomeFromHome = false;
      } else {
        this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
      }
    } else if (this.qmsservice.moduleName == 'DV') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = "DV";
      this.qmsservice.moduleName = "DV";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = this.qmsservice.moduleName;
      const data = this.router.url.split("/");
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName == undefined ? this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp : this.qmsservice.moduleFullName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
        this.activityGridComponent.reloadCurrentRoute();
      } else if (this.message.isTagHomeFromHome) {
        this.reportModuleMethod(this.qmsservice.moduleName);
        this.message.isTagHomeFromHome = false;
      } else {
        this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
      }
    } else if (this.qmsservice.moduleName == 'IN') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = "IN";
      this.qmsservice.moduleName = "IN";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = this.qmsservice.moduleName;
      this.message.showIncidentSwitch = false;
      const data = this.router.url.split("/");
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName == undefined ? this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp : this.qmsservice.moduleFullName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
        this.activityGridComponent.reloadCurrentRoute();
      } else if (this.message.isTagHomeFromHome) {
        this.reportModuleMethod(this.qmsservice.moduleName);
        this.message.isTagHomeFromHome = false;
      } else {
        this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
      }
    } else if (this.qmsservice.moduleName == 'QI') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = "QI";
      this.qmsservice.moduleName = "QI";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = this.qmsservice.moduleName;
      const data = this.router.url.split("/");
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName == undefined ? this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp : this.qmsservice.moduleFullName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
        this.activityGridComponent.reloadCurrentRoute();
      } else if (this.message.isTagHomeFromHome) {
        this.reportModuleMethod(this.qmsservice.moduleName);
        this.message.isTagHomeFromHome = false;
      } else {
        this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
      }
    } else if (this.qmsservice.moduleName == 'CC') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = "CC";
      this.qmsservice.moduleName = "CC";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = this.qmsservice.moduleName;
      this.message.showComplaintSwitch = false;
      const data = this.router.url.split("/");
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName == undefined ? this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp : this.qmsservice.moduleFullName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
        this.activityGridComponent.reloadCurrentRoute();
      } else if (this.message.isTagHomeFromHome) {
        this.reportModuleMethod(this.qmsservice.moduleName);
        this.message.isTagHomeFromHome = false;
      } else {
        this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
      }
    } else if (this.qmsservice.moduleName == 'OOS') {
      this.qmsservice.isTriggeredFromDependencies = false;
      this.qmsservice.refereshBreadCrumb = false;
      this.message.changeRequestCode = this.qmsservice.moduleName;

      this.message.changeRequestCode = "OOS";
      this.qmsservice.moduleName = "OOS";
      this.activityGridComponent.ngOnInit();
      this.qmsservice.activityTitle = this.qmsservice.moduleName;
      this.message.showComplaintSwitch = false;
      this.isProcessing = false;
      let secondlevelid = document.getElementById('secondLevelid') as HTMLInputElement;
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName == undefined ? this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp : this.qmsservice.moduleFullName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      if (secondlevelid) {
        secondlevelid.innerHTML = this.message.breadcrumbData.secondLevel
      }
      const data = this.router.url.split("/");
      if (data.at(-1) == this.qmsservice.moduleName && (data.at(-2) != "ActivityReportComponent" && data.at(-2) != 'MoreActivityReportDetailsComponent')) {
        this.activityGridComponent.reloadCurrentRoute();
      } else if (this.message.isTagHomeFromHome) {
        this.reportModuleMethod(this.qmsservice.moduleName);
        this.message.isTagHomeFromHome = false;
      } else {
        this.router.navigate(['/dashboard/ActivityCR', this.qmsservice.moduleName]);
      }

    }
  };


  @ViewChild(HomepagetagComponent) homepagetagComponent!: HomepagetagComponent;
  openTag(fromPage: any) {
    let data = {
      pageName: fromPage,
      labelName: "Tag",
      tagRef: null,
      taskId: 0
    }
    this.homepagetagComponent.openpopup(data);
  }

  onTagChildValueEmitted() {
    /*empty*/
  };

  clearcache() {
    this.router.navigate(['dashboard']);
    setTimeout(() => {                           // <<<---using ()=> syntax
      globalThis.location.reload();
    }, 750);
  };

  setgroupandModulenull() {

    const data = {
      groupId: null,
      moduleName: null
    }
    this.topNavService.callSetDefaultGrouop(data).subscribe((Response: any) => {
      this.isProcessing = false;
      this.visibleValidationConfirm.close();
    });
  }

  public getVendorMenu(): boolean {
    return this.qmsservice.showVendorMasterSection && this.qmsservice.moduleName == 'AU';
  }

  public getAuditMasterMenu(): boolean {
    return this.qmsservice.showAuditMasterSection && this.qmsservice.moduleName == 'AU';
  }

}


export interface PopupData {
  title: string;
}
